const ESB = {
  provider: 'ESB Energy',
  phone: '0345 609 0372',
  email: 'EVsupport@esbenergy.co.uk',
};

const ShellUbitricity = {
  provider: 'Shell Ubitricity',
  phone: '0800 024 6279',
  email: 'support@ubitricity.co.uk',
};

const SourceLondon = {
  provider: 'Source London',
  phone: '020 3056 8989',
  email: 'parkingbays@source-london.co.uk',
};

export const providers = {
  ESB,
  ShellUbitricity,
  SourceLondon,
};
